module.exports = __webpack_public_path__ + "static/media/callme.52e35196.png";